class PendingOrderRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'PendingOrder';
      const model = App.Models.PendingOrder;
      const collectionClass = App.Collections.PendingOrders;

      super(entityName, model, collectionClass);
  }
}

App.Routers.PendingOrder = PendingOrderRouter;
